import { render, staticRenderFns } from "./AdaptiveLayout.vue?vue&type=template&id=08bdbd1c&"
import script from "./AdaptiveLayout.vue?vue&type=script&lang=ts&"
export * from "./AdaptiveLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports